import React from 'react';

interface EventProps {
  month?: string;
  day?: string;
  hour?: string;
  category?: string;
  flag?: string;
  description?: string;
  speaker?: string;
  link?: string;
}

export default function Event({
  month,
  day,
  hour = '',
  category,
  flag,
  description,
  speaker,
  link,
}: EventProps) {
  return (
    <div className="py-8 px-4 lg:w-1/3">
      <div className="h-full flex items-start">
        <div className="w-12 flex-shrink-0 flex flex-col text-center leading-none">
          <span className="text-gray-500 pb-2 mb-2 border-b-2 border-gray-300">
            {month}
          </span>
          <span className="font-medium text-xl text-gray-800 title-font">
            {day}
          </span>
        </div>
        <div className="flex-grow pl-6 flex flex-col flex-wrap h-full">
          <h2 className="tracking-widest text-xs title-font font-medium text-blue-700 mb-1">
            {category}
          </h2>
          <a href={link} target="_blank" rel="noopener noreferrer">
            <h2 className="leading-relaxed mb-1">{description}</h2>
          </a>
          <p className="leading-relaxed text-sm text-gray-500 mb-2">{hour}</p>
          <a className="inline-flex items-center mt-auto">
            <img
              alt="Country Flag"
              src={flag}
              className="w-8 h-8 rounded-full flex-shrink-0 object-cover object-center"
            />
            <span className="flex-grow flex flex-col pl-3">
              <a href={link} target="_blank" rel="noopener noreferrer">
                <span className="title-font font-medium text-gray-900">
                  {speaker}
                </span>
              </a>
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}
